/** @format */

import { CommonModule, isPlatformBrowser } from '@angular/common';
import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	Input,
	OnDestroy,
	OnInit,
	PLATFORM_ID,
	ViewChild,
	ViewContainerRef
} from '@angular/core';

import { Store } from '@ngrx/store';

import { selectProductListSEO, setHomrBannerData } from '@plp/data-access/state';
import { takeUntil, Subject } from 'rxjs';
import { ComponentBindings } from './homr-banner-modules';
import { DynamicTemplateLoader } from '@shared/utils/services';
import { HomrDataService } from '@shared/homr/data-access';
import { HomeFieldRecommendationCardModule, HomefieldButtonModule } from '@homefield';

@Component({
    selector: 'plp-homr-components-template',
    templateUrl: './homr-template.component.html',
    styleUrls: ['./homr-template.component.scss'],
    imports: [CommonModule, HomefieldButtonModule, HomeFieldRecommendationCardModule],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomrTemplateComponent implements OnInit, OnDestroy {
	@Input() chainAbbr = '';

	private readonly UNSUBSCRIBE$: Subject<void> = new Subject();

	readonly productListSEOData$ = this.store
		.select(selectProductListSEO)
		.pipe(takeUntil(this.UNSUBSCRIBE$));

	bannerInfo;
	components;

	@ViewChild('templateOutlet', { read: ViewContainerRef })
	templateOutlet: ViewContainerRef;

	constructor(
		private homrDataService: HomrDataService,
		private store: Store,
		@Inject(PLATFORM_ID) private platformId,
		private dynamicTemplateLoader: DynamicTemplateLoader
	) {
		this.components = ComponentBindings();
	}

	ngOnInit() {
		if (isPlatformBrowser(this.platformId)) {
			this.productListSEOData$.subscribe((productListSEOData) => {
				this.homrDataService
					.getData$('banner', 2, productListSEOData?.seoUrl)
					.pipe(takeUntil(this.UNSUBSCRIBE$))
					.subscribe((bannerInfo) => {
						this.bannerInfo = bannerInfo;
						this.store.dispatch(setHomrBannerData({ homrBannerData: bannerInfo }));
						this.loadTemplate();
					});
			});
		}
	}

	async loadTemplate() {
		if (this.bannerInfo) {
			const keys = Object.keys(this.bannerInfo.content);
			for (const k in keys) {
				if (this.bannerInfo.content[keys[k]]) {
					const key = keys[k];
					const data = this.bannerInfo.content[key];
					if (this.components[key]) {
						await this.components[key](
							this.dynamicTemplateLoader,
							data,
							this.templateOutlet,
							{ tagSectionNum: +k + 1, widgetTypeTag: key, chainAbbr: this.chainAbbr }
						);
					}
				}
			}
		}
	}

	ngOnDestroy(): void {
		this.UNSUBSCRIBE$.next();
		this.UNSUBSCRIBE$.complete();
	}
}
